import styled from 'styled-components';
var MoreAvailabilityContainer = styled.div.withConfig({
  displayName: "MoreAvailabilitystyles__MoreAvailabilityContainer",
  componentId: "sc-1fiuw9f-0"
})(["background:", ";padding:15px;"], function (props) {
  return props.theme.color.monochrome.base;
});
var MoreAvailabilitySection = styled.section.withConfig({
  displayName: "MoreAvailabilitystyles__MoreAvailabilitySection",
  componentId: "sc-1fiuw9f-1"
})([""]);
var MoreAvailabilityFeaturePanel = styled.div.withConfig({
  displayName: "MoreAvailabilitystyles__MoreAvailabilityFeaturePanel",
  componentId: "sc-1fiuw9f-2"
})(["margin-bottom:0;padding:20px;background:", ";border:1px solid ", ";border-radius:3px;display:block;overflow:hidden;position:relative;cursor:pointer;text-align:center;"], function (props) {
  return props.theme.color.monochrome.white;
}, function (props) {
  return props.theme.color.monochrome.light;
});
var MoreAvailabilityTitle = styled.p.withConfig({
  displayName: "MoreAvailabilitystyles__MoreAvailabilityTitle",
  componentId: "sc-1fiuw9f-3"
})(["&&&{font-weight:", ";}font-size:20px;max-width:300px;margin-left:auto;margin-right:auto;"], function (props) {
  return props.theme.font.weight.bold;
});
var MoreAvailabilityText = styled.p.withConfig({
  displayName: "MoreAvailabilitystyles__MoreAvailabilityText",
  componentId: "sc-1fiuw9f-4"
})(["margin-top:7px;margin-left:auto;margin-right:auto;"]);
var MoreAvailabilityHeader = styled.div.withConfig({
  displayName: "MoreAvailabilitystyles__MoreAvailabilityHeader",
  componentId: "sc-1fiuw9f-5"
})(["padding:20px;background:", ";border:1px solid ", ";border-radius:3px;font-weight:", ";display:block;overflow:hidden;margin-bottom:5px;cursor:pointer;position:relative;text-align:center;"], function (props) {
  return props.theme.color.monochrome.white;
}, function (props) {
  return props.theme.color.monochrome.light;
}, function (props) {
  return props.theme.font.weight.bold;
});
export { MoreAvailabilityContainer, MoreAvailabilitySection, MoreAvailabilityFeaturePanel, MoreAvailabilityTitle, MoreAvailabilityText, MoreAvailabilityHeader };